/* eslint-disable react/no-danger */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import parseHtml from 'html-react-parser';
import cx from 'classnames';

import constants from '../../utils/constants';

const Banner = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const [bannerText, setBannerText] = useState('');

  const CheckBannerDate = (startDate, endDate, now) => {
    const parsedStartDate = new Date(startDate);
    const parsedEndDate = new Date(endDate);
    if (now < parsedStartDate || parsedEndDate < now) {
      return false;
    }
    return true;
  };

  const CheckPartner = (partnerId, bannerPartners) => {
    let shouldShowBannerId = false;
    bannerPartners.forEach(partnerObject => {
      if (partnerObject.PartnerID == partnerId) {
        shouldShowBannerId = true;
      }
    });
    return shouldShowBannerId;
  };

  useEffect(() => {
    const currentDateTime = new Date();

    const setBannerState = async () => {
      const { emailAddress, partnerId, phoneNumber } = constants;

      const { data } = await axios.get(
        'https://s3.amazonaws.com/banners.kabbage.com/notification_banners.json'
      );

      const banners = data;
      banners.forEach(banner => {
        const newShouldShowState =
          CheckBannerDate(
            banner.start_date,
            banner.end_date,
            currentDateTime
          ) && CheckPartner(partnerId, banner.partners);
        setShouldShow(newShouldShowState);
        if (newShouldShowState === true) {
          const processingText = banner.banner_text;
          setBannerText(
            processingText
              .replace(
                '<<Partner Customer Service Email Address>>',
                `<a href="mailto:${emailAddress}">${emailAddress}</a>`
              )
              .replace(
                '<<Partner phone number>>',
                `<a href="tel:${phoneNumber}">${phoneNumber}</a>`
              )
              .replace(
                '<<partner phone number>>',
                `<a href="tel:${phoneNumber}">${phoneNumber}</a>`
              )
          );
          if (typeof window !== 'undefined') {
            const appElement = document.getElementsByTagName('body')[0];
            appElement.setAttribute('data-show-message', 'true');
          }
        }
      });
    };
    setBannerState();
  }, []);

  return (
    <div className={cx('message-section', { visuallyHidden: !shouldShow })}>
      <div className={cx('message', { shouldShow })}>
        <div className="container">{parseHtml(bannerText)}</div>
      </div>
    </div>
  );
};

export default Banner;
